import AdditionalAmenitiesModal from "../../../Components/User/AdditionalAmenitiesModal/AdditionalAmenitiesModal";
import {
  clearMemberByEmail,
  getMemberByEmail,
  signupUser,
} from "../../../Redux/Auth/AuthActions";
import AdditionalAddonsModal from "../../../Components/User/AdditionalAddonsModal/AdditionalAddonsModal";
import { ColDef, GetRowIdParams, ICellRendererParams } from "ag-grid-community";
import MobileHeader from "../../../Components/User/MobileHeader/MobileHeader";
import { ReactComponent as TickIcon } from "../../../Assets/Tick.svg";
import { FaFilePdf, FaRegEye, FaRegEyeSlash } from "react-icons/fa6";
import React, { useEffect, useMemo, useRef, useState } from "react";
import Stepper from "../../../Components/Common/Stepper/Stepper";
import Loading from "../../../Components/Common/Loading/Loading";
import { Menu, MenuButton, MenuItem } from "@szhsin/react-menu";
import { AppDispatch, RootState } from "../../../Redux/store";
import Header from "../../../Components/User/Header/Header";
import Modal from "../../../Components/Common/Modal/Modal";
import { useDispatch, useSelector } from "react-redux";
import generateUuid from "../../../Util/generateUuid";
import SignatureCanvas from "react-signature-canvas";
import toastHelper from "../../../Util/toastHelper";
import { Link, useNavigate } from "react-router";
import validator from "../../../Util/validator";
import { HiDotsVertical } from "react-icons/hi";
import { Switch } from "react-animated-switch";
import { IoIosWarning } from "react-icons/io";
import { AgGridReact } from "ag-grid-react";
import styles from "./Signup.module.scss";
import API from "../../../API/API";
import html2pdf from "html2pdf.js";
import moment from "moment";
import axios from "axios";
import {
  getDefaultPeriod,
  getPackageBaseRate,
  getPackagePeriods,
  getPackagePrice,
  getPeriodLabel,
  getPeriodSuffix,
  hasPackageDiscount,
  hasPackageFreeTrial,
  getPackageTrialDays,
} from "../../../Util/packageRates";

interface FamilyMember {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  bookingAllowed: boolean;
}

type AddonSelection = {
  addonId: number;
  noofAddonUnits: number;
  notifyAddon: boolean;
};

const Step1 = ({
  email,
  setEmail,
  password,
  setPassword,
  confirmPassword,
  setConfirmPassword,
  showPassword,
  setShowPassword,
  showConfirmPassword,
  setShowConfirmPassword,
  errors,
}: {
  email: string;
  setEmail: (email: string) => void;
  password: string;
  setPassword: (password: string) => void;
  confirmPassword: string;
  setConfirmPassword: (confirmPassword: string) => void;
  showPassword: boolean;
  setShowPassword: (showPassword: boolean) => void;
  showConfirmPassword: boolean;
  setShowConfirmPassword: (showConfirmPassword: boolean) => void;
  errors: {
    email: string;
    password: string;
    confirmPassword: string;
  };
}) => {
  return (
    <div className={styles.stepOneContainer}>
      <div className={styles.headingContainer}>
        <p className={styles.label}>Email verification</p>
      </div>
      <form className={styles.stepOneForm}>
        <div className={styles.inputContainer}>
          <p className={styles.label}>Email</p>
          <input
            className={styles.input}
            type="email"
            value={email}
            autoComplete="email"
            onChange={(e) => setEmail(e.target.value)}
          />
          <p className={styles.error}>{errors.email}</p>
        </div>

        <div className={styles.inputContainer}>
          <p className={styles.label}>Password</p>
          <div className={styles.passwordInputContainer}>
            <input
              type={showPassword ? "text" : "password"}
              className={styles.input}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
            />
            <button
              type="button"
              className={styles.showPasswordButton}
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? (
                <FaRegEyeSlash className={styles.icon} />
              ) : (
                <FaRegEye className={styles.icon} />
              )}
            </button>
          </div>
          <p className={styles.error}>{errors.password}</p>
        </div>
        <div className={styles.inputContainer}>
          <p className={styles.label}>Confirm Password</p>
          <div className={styles.passwordInputContainer}>
            <input
              type={showConfirmPassword ? "text" : "password"}
              className={styles.input}
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              autoComplete="current-password"
            />
            <button
              type="button"
              className={styles.showPasswordButton}
              onClick={() => setShowConfirmPassword(!showConfirmPassword)}
            >
              {showConfirmPassword ? (
                <FaRegEyeSlash className={styles.icon} />
              ) : (
                <FaRegEye className={styles.icon} />
              )}
            </button>
          </div>
          <p className={styles.error}>{errors.confirmPassword}</p>
        </div>
      </form>
    </div>
  );
};

const Step6 = ({
  memberByEmail,
  email,
  voucherCode,
  setVoucherCode,
  voucherSuccess,
  setVoucherSuccess,
  cardHolderName,
  setCardHolderName,
  cardNumber,
  setCardNumber,
  expiry,
  setExpiry,
  cvv,
  setCvv,
  errors,
  packageData,
  setErrors,
  parkingIds,
  parkingList,
  addonSelections,
  selectedPeriod,
}: {
  memberByEmail: any;
  email: string;
  voucherCode: string;
  setVoucherCode: React.Dispatch<React.SetStateAction<string>>;
  voucherSuccess: any;
  setVoucherSuccess: React.Dispatch<React.SetStateAction<any>>;
  cardHolderName: string;
  setCardHolderName: React.Dispatch<React.SetStateAction<string>>;
  cardNumber: string;
  setCardNumber: React.Dispatch<React.SetStateAction<string>>;
  expiry: string;
  setExpiry: React.Dispatch<React.SetStateAction<string>>;
  cvv: string;
  setCvv: React.Dispatch<React.SetStateAction<string>>;
  errors: {
    cardHolderName: string;
    cardNumber: string;
    expiry: string;
    cvv: string;
    voucherCode: string;
  };
  setErrors: React.Dispatch<
    React.SetStateAction<{
      cardHolderName: string;
      cardNumber: string;
      expiry: string;
      cvv: string;
      voucherCode: string;
      firstName: string;
      lastName: string;
      phoneNumber: string;
      email: string;
      password: string;
      confirmPassword: string;
    }>
  >;
  packageData: any;
  parkingIds: number[];
  parkingList: any[];
  addonSelections: AddonSelection[];
  selectedPeriod: string;
}) => {
  const applyVoucherHandler = async () => {
    if (voucherCode.trim() !== "") {
      setErrors((prev) => ({
        ...prev,
        voucherCode: "",
      }));
      try {
        const { data } = await axios({
          url: `${API.members.validateVoucher.url}?voucherCode=${voucherCode}&email=${email}&voucherType=1`,
          method: API.members.validateVoucher.method,
        });
        setVoucherSuccess(data);
      } catch (error: any) {
        if (error?.response?.data?.message) {
          setErrors((prev) => ({
            ...prev,
            voucherCode: error?.response?.data?.message ?? "",
          }));
        } else {
          setErrors((prev) => ({
            ...prev,
            voucherCode: "Something went wrong",
          }));
        }
      }
    } else {
      setErrors((prev) => ({
        ...prev,
        voucherCode: "Voucher code is required",
      }));
    }
  };

  const removeVoucherHandler = () => {
    setVoucherSuccess(null);
    setVoucherCode("");
  };

  const monthlySubtotalBeforeVoucher = useMemo(() => {
    const packageRate = getPackagePrice(packageData, selectedPeriod);

    const parkingTotal = (parkingList || []).reduce((acc: number, parking: any) => {
      const slotIds = (parking?.parkingdata ?? []).map(
        (slot: { ParkingId: number }) => slot.ParkingId,
      );
      const selectedCount = parkingIds.filter((id) =>
        slotIds.includes(id),
      ).length;
      return (
        acc + Number(parking?.rates ?? parking?.cost ?? 0) * selectedCount
      );
    }, 0);

    const addonTotal = addonSelections.reduce((acc, selection) => {
      const addon = memberByEmail?.addon?.find(
        (a: any) => a.addonId === selection.addonId,
      );

      return (
        acc + Number(addon?.cost ?? 0) * Number(selection.noofAddonUnits ?? 0)
      );
    }, 0);

    return packageRate + parkingTotal + addonTotal;
  }, [packageData, selectedPeriod, parkingIds, addonSelections, parkingList, memberByEmail]);

  const voucherDiscountAmount = useMemo(() => {
    if (!voucherSuccess?.success || !voucherSuccess?.voucher) return 0;

    const { percent, maxDiscount } = voucherSuccess.voucher;
    const percentValue = Number(percent ?? 0);

    let discount = (monthlySubtotalBeforeVoucher * percentValue) / 100;

    if (maxDiscount !== null && maxDiscount !== undefined) {
      discount = Math.min(discount, Number(maxDiscount));
    }

    return Number(discount.toFixed(2));
  }, [monthlySubtotalBeforeVoucher, voucherSuccess]);

  return (
    <div className={styles.stepSixContainer}>
      <div className={styles.stepFiveContentWrapper}>
        <div className={styles.packageInfoWrapper}>
          <div className={styles.packageInfoContainer}>
            <p className={styles.label}>Package Selected</p>

            <p className={styles.packageName}>
              {packageData?.packageName}
              {selectedPeriod ? ` (${getPeriodLabel(selectedPeriod)})` : ""} - $
              {getPackagePrice(packageData, selectedPeriod)}
              {getPeriodSuffix(selectedPeriod)}
            </p>
            {hasPackageFreeTrial(packageData) && (
              <p className={styles.trialNotice}>
                You have a {getPackageTrialDays(packageData)}-day free trial.
                You will be charged after the trial ends.
              </p>
            )}
          </div>

          {parkingIds.length > 0 && (
            <div className={styles.additionalAmenitiesContainer}>
              <p className={styles.label}>Additional Amenities</p>

              <div className={styles.amenitiesList}>
                {(parkingList || []).map((parking: any) => {
                  const slotIds = (parking?.parkingdata ?? []).map(
                    (slot: { ParkingId: number }) => slot.ParkingId,
                  );
                  const selectedCount = parkingIds.filter((id) =>
                    slotIds.includes(id),
                  ).length;

                  if (selectedCount === 0) return null;

                  return (
                    <div key={parking?.amenityId} className={styles.amenity}>
                      <p className={styles.label}>
                        {parking?.name ?? parking?.amenityName} - Parking
                      </p>

                      <p className={styles.price}>
                        $
                        {(parking?.rates ?? parking?.cost ?? 0) * selectedCount}
                      </p>
                    </div>
                  );
                })}
              </div>
            </div>
          )}

          {addonSelections.some((s) => s.noofAddonUnits > 0) && (
            <div className={styles.additionalAmenitiesContainer}>
              <p className={styles.label}>Additional Addons</p>

              <div className={styles.amenitiesList}>
                {addonSelections.map((selection, i) => {
                  const addon = memberByEmail?.addon?.find(
                    (a: any) => a.addonId === selection.addonId,
                  );

                  if (!addon || selection.noofAddonUnits <= 0) return null;

                  return (
                    <div key={i} className={styles.amenity}>
                      <p className={styles.label}>
                        {addon?.amenityName} - Addon
                      </p>

                      <p className={styles.price}>
                        ${(addon?.cost ?? 0) * selection.noofAddonUnits}
                      </p>
                    </div>
                  );
                })}
              </div>
            </div>
          )}

          {!voucherSuccess ? (
            <div className={styles.couponInputContainer}>
              <div className={styles.couponInputBox}>
                <input
                  className={styles.input}
                  type="text"
                  placeholder="Enter Voucher Code"
                  value={voucherCode}
                  onChange={(e) => {
                    const value = e.target.value.replace(/\s/g, "");

                    setVoucherCode(value);
                  }}
                />

                <p className={styles.error}>{errors.voucherCode}</p>
              </div>

              <button className={styles.button} onClick={applyVoucherHandler}>
                Apply
              </button>
            </div>
          ) : (
            <div className={styles.couponSuccessContainer}>
              <p className={styles.heading}>Coupon Applied</p>

              <div className={styles.voucherContainer}>
                <p className={styles.voucherCode}>{voucherCode}</p>

                <p className={styles.voucherDiscount}>
                  ${voucherDiscountAmount}
                </p>
              </div>

              <div className={styles.buttonContainer}>
                <button
                  className={styles.button}
                  onClick={removeVoucherHandler}
                >
                  Remove Voucher
                </button>
              </div>
            </div>
          )}
        </div>
        <div className={styles.headingContainer}>
          <p className={styles.label}>Enter card information</p>
        </div>
        <div className={styles.inputContainer}>
          <p className={styles.label}>Card Holder Name</p>
          <input
            className={styles.input}
            type="text"
            value={cardHolderName}
            onChange={(e) => setCardHolderName(e.target.value)}
          />
          <p className={styles.error}>{errors.cardNumber}</p>
        </div>
        <div className={styles.inputContainer}>
          <p className={styles.label}>Card Number</p>
          <input
            className={styles.input}
            type="text"
            value={cardNumber}
            maxLength={19}
            onChange={(e) => {
              let val = e.target.value.replace(/\D/g, "");
              val = val.match(/.{1,4}/g)?.join(" ") || "";
              setCardNumber(val);
            }}
          />
          <p className={styles.error}>{errors.cardNumber}</p>
        </div>
        <div className={styles.doubleInputContainer}>
          <div className={styles.inputContainer}>
            <p className={styles.label}>Expiration Date</p>
            <input
              className={styles.input}
              type="text"
              value={expiry}
              maxLength={5}
              onChange={(e) => {
                let val = e.target.value;
                val = val.replace(/[^\d\\/]/g, "");
                val = val.replace(/\//g, "");
                if (val.length > 2)
                  val = val.slice(0, 2) + "/" + val.slice(2, 4);
                setExpiry(val);
              }}
            />
            <p className={styles.error}>{errors.expiry}</p>
          </div>
          <div className={styles.inputContainer}>
            <p className={styles.label}>CVV</p>
            <input
              className={styles.input}
              type="text"
              value={cvv}
              onChange={(e) => setCvv(e.target.value)}
            />
            <p className={styles.error}>{errors.cvv}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

const Step4 = ({
  familyMembers,
  setFamilyMembers,
  packageData,
}: {
  familyMembers: FamilyMember[];
  setFamilyMembers: React.Dispatch<React.SetStateAction<FamilyMember[]>>;
  packageData: any;
}) => {
  const [firstName, setFirstName] = useState<string>("");
  const [lastName, setLastName] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const [phoneNumber, setPhoneNumber] = useState<string>("");
  const [errors, setErrors] = useState<{
    firstName: string;
    lastName: string;
    email: string;
    phoneNumber: string;
  }>({
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
  });

  const addMemberHandler = () => {
    if (packageData?.noofMembers < familyMembers.length) {
      toastHelper.error(
        "You have reached the maximum number of family members",
      );
      return;
    }

    const { errors: fieldErrors, isValid } = validator([
      {
        key: "firstName",
        type: "text",
        value: firstName,
      },
      {
        key: "lastName",
        type: "text",
        value: lastName,
      },
      {
        key: "email",
        type: "email",
        value: email,
      },
      {
        key: "phoneNumber",
        type: "text",
        value: phoneNumber,
      },
    ]);

    setErrors((prev) => ({
      ...prev,
      ...fieldErrors,
    }));

    if (isValid) {
      const emailExists = familyMembers.some(
        (member) => member.email === email,
      );
      if (emailExists) {
        setErrors((prev) => ({
          ...prev,
          email: "Email already exists",
        }));
        return;
      }
      setFamilyMembers((prev) => [
        ...prev,
        {
          id: generateUuid(),
          firstName,
          lastName,
          email,
          phoneNumber,
          bookingAllowed: false,
        },
      ]);
      memberClearHandler();
    }
  };

  const deleteMemberHandler = (id: string) => {
    setFamilyMembers((prev) => prev.filter((member) => member.id !== id));
  };

  const memberClearHandler = () => {
    setFirstName("");
    setLastName("");
    setEmail("");
    setPhoneNumber("");
    setErrors({
      firstName: "",
      lastName: "",
      email: "",
      phoneNumber: "",
    });
  };

  const columnDefs = useMemo<ColDef<FamilyMember>[]>(
    () => [
      {
        headerName: "First Name",
        field: "firstName",
        flex: 1,
      },
      {
        headerName: "Last Name",
        field: "lastName",
        flex: 1,
      },
      {
        headerName: "Email",
        field: "email",
        flex: 1,
      },
      {
        headerName: "Phone",
        field: "phoneNumber",
        flex: 1,
      },
      {
        headerName: "Booking Allowed",
        field: "bookingAllowed",
        flex: 1,
        cellRenderer: (params: ICellRendererParams<FamilyMember>) => (
          <Switch
            inActiveTrackColor="#DFDFDF"
            activeTrackColor="#C0F496"
            inActiveThumbColor="#000000"
            activeThumbColor="#000000"
            checked={params?.data?.bookingAllowed ?? false}
            onChange={(val) => {
              setFamilyMembers((prev) =>
                prev.map((member) =>
                  member.id === params?.data?.id
                    ? {
                      ...member,
                      bookingAllowed: val,
                    }
                    : member,
                ),
              );
            }}
          />
        ),
      },
      {
        sortable: false,
        suppressAutoSize: true,
        suppressMovable: true,
        suppressNavigable: true,
        width: 100,
        editable: false,
        cellStyle: {
          pointerEvents: "all",
          userSelect: "none",
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
        },
        cellRenderer: (params: ICellRendererParams<FamilyMember>) => (
          <div className={styles.iconContainer}>
            <Menu
              direction="left"
              menuButton={
                <MenuButton>
                  <HiDotsVertical className={styles.icon} />
                </MenuButton>
              }
              transition
              portal
            >
              <MenuItem
                onClick={() => deleteMemberHandler(params?.data?.id ?? "")}
              >
                Delete
              </MenuItem>
            </Menu>
          </div>
        ),
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [setFamilyMembers],
  );

  const defaultColDef = useMemo<ColDef<FamilyMember>>(
    () => ({
      resizable: true,
      sortable: true,
      filter: false,
      wrapText: true,
      autoHeight: true,
      unSortIcon: true,
    }),
    [],
  );

  return (
    <div className={styles.stepFourContainer}>
      <div className={styles.headingContainer}>
        <p className={styles.label}>Add Family Members</p>
      </div>
      <div className={styles.familyMembersContainer}>
        <div className={styles.gridContainer}>
          <AgGridReact
            className={styles.grid}
            rowData={familyMembers}
            columnDefs={columnDefs}
            defaultColDef={defaultColDef}
            getRowId={(params: GetRowIdParams<FamilyMember>) => params.data.id}
            animateRows
            domLayout="autoHeight"
          />
        </div>
        <div className={styles.formContainer}>
          <div className={styles.inputContainer}>
            <p className={styles.label}>First Name</p>
            <input
              className={styles.input}
              type="text"
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
            />
            <p className={styles.error}>{errors.firstName}</p>
          </div>
          <div className={styles.inputContainer}>
            <p className={styles.label}>Last Name</p>
            <input
              className={styles.input}
              type="text"
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
            />
            <p className={styles.error}>{errors.lastName}</p>
          </div>
          <div className={styles.inputContainer}>
            <p className={styles.label}>Email</p>
            <input
              className={styles.input}
              type="text"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <p className={styles.error}>{errors.email}</p>
          </div>
          <div className={styles.inputContainer}>
            <p className={styles.label}>Phone Number</p>
            <input
              className={styles.input}
              type="text"
              value={phoneNumber}
              onChange={(e) => {
                const value = e.target.value;
                if (/^\d*$/.test(value)) {
                  setPhoneNumber(value);
                }
              }}
            />
            <p className={styles.error}>{errors.phoneNumber}</p>
          </div>
          <div className={styles.buttonsContainer}>
            <button className={styles.button} onClick={addMemberHandler}>
              Add Member
            </button>
            <button className={styles.clearButton} onClick={memberClearHandler}>
              Clear
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

function Signup() {
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const signRef = useRef<SignatureCanvas>(null);
  const {
    memberByEmailLoading,
    memberByEmail,
    signupLoading,
    memberByEmailError,
  } = useSelector((state: RootState) => state.auth);

  const [voucherCode, setVoucherCode] = useState<string>("");
  const [voucherSuccess, setVoucherSuccess] = useState<any>(null);
  const [currentStep, setCurrentStep] = useState<number>(0);
  const [email, setEmail] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [confirmPassword, setConfirmPassword] = useState<string>("");
  const [selectedPackage, setSelectedPackage] = useState<number>(-1);
  const [selectedPeriod, setSelectedPeriod] = useState<string>("");
  const [cardHolderName, setCardHolderName] = useState<string>("");
  const [cardNumber, setCardNumber] = useState<string>("");
  const [expiry, setExpiry] = useState<string>("");
  const [cvv, setCvv] = useState<string>("");
  const [signature, setSignature] = useState<string>("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [familyMembers, setFamilyMembers] = useState<FamilyMember[]>([]);
  const [nonMemberModal, setNonMemberModal] = useState(false);
  const [parkingIds, setParkingIds] = useState<number[]>([]);
  const [notifyParkingIds, setNotifyParkingIds] = useState<number[]>([]);
  const [addonSelections, setAddonSelections] = useState<AddonSelection[]>([]);
  const [additionalAmenitiesModal, setAdditionalAmenitiesModal] =
    useState(false);
  const [additionalAddonsModal, setAdditionalAddonsModal] = useState(false);
  const [errors, setErrors] = useState<{
    firstName: string;
    lastName: string;
    phoneNumber: string;
    email: string;
    password: string;
    confirmPassword: string;
    cardHolderName: string;
    cardNumber: string;
    expiry: string;
    cvv: string;
    voucherCode: string;
  }>({
    email: "",
    password: "",
    confirmPassword: "",
    cardHolderName: "",
    cardNumber: "",
    expiry: "",
    cvv: "",
    firstName: "",
    lastName: "",
    phoneNumber: "",
    voucherCode: "",
  });

  const packageData: any = useMemo(() => {
    return memberByEmail?.packages?.find(
      (pack: any) => Number(pack.packageId) === Number(selectedPackage),
    );
  }, [memberByEmail, selectedPackage]);

  useEffect(() => {
    if (memberByEmailError) {
      if (memberByEmailError?.status === 404) {
        setNonMemberModal(true);
      }
    }

    return () => {
      dispatch(clearMemberByEmail());
    };
  }, [memberByEmailError, dispatch]);

  const maxSteps = 6;

  const nextStepHandler = () => {
    let step = currentStep + 1;
    if (step === maxSteps) {
      if (!signupLoading) {
        const successHandler = () => {
          navigate("/login", {
            replace: true,
            state: { signup_success: true },
          });
        };

        dispatch(
          signupUser(
            {
              email,
              password,
              packageId: selectedPackage,
              period: selectedPeriod,
              content: "signature",
              signature: signature,
              cardNumber: cardNumber.replace(/\s/g, ""),
              cardName: cardHolderName,
              expiry: expiry.replace(/\//g, ""),
              cvv: cvv,
              parkingIds,
              notifyParkingIds,
              addons: addonSelections.filter((s) => s.noofAddonUnits > 0),
              familyMember: packageData?.isFamily ? familyMembers : [],
              voucherCode: voucherSuccess?.voucher?.name,
            },
            successHandler,
          ),
        );
      } else {
        toastHelper.error("Please wait for the signup to complete");
      }
    } else {
      if (currentStep === 2 && packageData?.isFamily) {
        setCurrentStep(step);
        return;
      } else if (currentStep === 2 && !packageData?.isFamily) {
        setCurrentStep(step + 1);
      } else {
        setCurrentStep(step);
      }
    }
  };

  const backStepHandler = () => {
    const step = currentStep - 1;
    if (step >= 0) {
      if (currentStep === 4 && packageData?.isFamily) {
        setCurrentStep(step);
      } else if (currentStep === 4 && !packageData?.isFamily) {
        setCurrentStep(step - 1);
      } else {
        setCurrentStep(step);
      }
    }
  };

  const stepHandler = () => {
    if (currentStep === 0) {
      if (!memberByEmailLoading) {
        const { errors: fieldErrors, isValid } = validator([
          {
            key: "email",
            type: "email",
            value: email,
          },
          {
            key: "password",
            type: "password",
            value: password,
          },
          {
            key: "confirmPassword",
            type: "confirmPassword",
            value: confirmPassword,
          },
        ]);
        setErrors({ ...errors, ...fieldErrors });
        if (isValid) {
          dispatch(
            getMemberByEmail({
              email,
              nextStepHandler,
            }),
          );
        }
      }
    }

    if (currentStep === 1) {
      nextStepHandler();
    }

    if (currentStep === 2) {
      if (Number(selectedPackage) !== -1) {
        if (!selectedPeriod) {
          toastHelper.error("Please select a package period");
          return;
        }
        nextStepHandler();
      } else {
        toastHelper.error("Please select a package");
      }
    }

    if (currentStep === 3) {
      if (familyMembers.length === 0) {
        toastHelper.error("Please add at least one member");
        return;
      }
      nextStepHandler();
    }

    if (currentStep === 4) {
      if (signRef?.current) {
        if (signRef.current.isEmpty()) {
          toastHelper.error("Please sign the agreement");
        } else {
          setSignature(signRef.current.toDataURL());
          nextStepHandler();
        }
      }
    }

    if (currentStep === 5) {
      const { errors: fieldErrors, isValid } = validator([
        {
          key: "cardHolderName",
          type: "text",
          value: cardHolderName,
        },
        {
          key: "cardNumber",
          type: "text",
          value: cardNumber,
        },
        {
          key: "expiry",
          type: "text",
          value: expiry,
        },
        {
          key: "cvv",
          type: "text",
          value: cvv,
        },
      ]);

      setErrors({ ...errors, ...fieldErrors });
      if (isValid) {
        nextStepHandler();
      }
    }
  };

  const Step2 = () => {
    return (
      <div className={styles.stepTwoContainer}>
        <div className={styles.headingContainer}>
          <p className={styles.label}>Review your information</p>
        </div>
        <div className={styles.infoContainer}>
          <div className={styles.locationContainer}>
            <div className={styles.imageContainer}>
              <img
                className={styles.image}
                src={memberByEmail?.building?.image}
                alt=""
              />
            </div>
            <div className={styles.locationInfo}>
              <p className={styles.name}>{memberByEmail?.building?.name}</p>
              <p className={styles.address}>
                {memberByEmail?.building?.address},{" "}
                {memberByEmail?.building?.city},{" "}
                {memberByEmail?.building?.state}, {memberByEmail?.building?.zip}
              </p>
            </div>
          </div>
          <div className={styles.clientContainer}>
            <p className={styles.name}>{memberByEmail?.member?.fullName}</p>
            <p className={styles.agreementDate}>
              Lease Agreement last updated on{" "}
              <span className={styles.highlighted}>
                {memberByEmail?.lease?.startDate
                  ? moment(memberByEmail?.lease?.startDate).format("MM/DD/YYYY")
                  : ""}
              </span>
            </p>
          </div>
        </div>
      </div>
    );
  };

  const Step3 = () => {
    return (
      <div className={styles.stepThreeContainer}>
        <div className={styles.headingContainer}>
          <p className={styles.label}>Select package</p>
        </div>
        <div className={styles.additionalbuttonInline}>
          {memberByEmail?.parking?.length > 0 && (
            <div className={styles.additionalbuttonContainer}>
              <button onClick={() => setAdditionalAmenitiesModal(true)}>
                Select Additional Amenities
              </button>
            </div>
          )}

          {memberByEmail?.addon?.length > 0 && Number(selectedPackage) !== -1 && (
            <div className={styles.additionalbuttonContainer}>
              <button onClick={() => setAdditionalAddonsModal(true)}>
                Select Additional Addons
              </button>
            </div>
          )}
        </div>
        <div className={styles.packagesContainer}>
          {memberByEmail?.packages?.map((pack: any, i: number) => {
            const periods = getPackagePeriods(pack);
            const isSelected =
              Number(selectedPackage) === Number(pack?.packageId);
            const activePeriod =
              isSelected && selectedPeriod
                ? selectedPeriod
                : getDefaultPeriod(pack);
            const displayPrice = getPackagePrice(pack, activePeriod);
            const baseRate = getPackageBaseRate(pack, activePeriod);
            const showDiscount = hasPackageDiscount(pack, activePeriod);
            const suffix = getPeriodSuffix(activePeriod);

            return (
              <div key={i} className={styles.package}>
                <div className={styles.infoContainer}>
                  <p className={styles.name}>{pack?.packageName}</p>
                  <div className={styles.priceContainer}>
                    {showDiscount ? (
                      <>
                        <p className={styles.price}>
                          ${displayPrice}
                          {suffix}
                        </p>
                        <p className={styles.cancelledPrice}>
                          ${baseRate}
                          {suffix}
                        </p>
                      </>
                    ) : (
                      <p className={styles.price}>
                        ${displayPrice}
                        {suffix}
                      </p>
                    )}
                  </div>
                </div>
                {
                  <div className={styles.trialContainer}>
                    {hasPackageFreeTrial(pack) && (
                      <p className={styles.label}>
                        This package has a limited time free trial -{" "}
                        {getPackageTrialDays(pack)} {getPackageTrialDays(pack) > 1 ? "Days" : "Day"}
                      </p>
                    )}
                  </div>
                }
                {periods.length > 0 && (
                  <div className={styles.periodsContainer}>
                    {periods.map((rate) => (
                      <button
                        key={rate.period}
                        type="button"
                        className={
                          isSelected &&
                          String(selectedPeriod || "") ===
                            String(rate.period || "")
                            ? styles.periodSelected
                            : styles.period
                        }
                        onClick={() => {
                          if (
                            Number(selectedPackage) ===
                              Number(pack?.packageId) &&
                            String(selectedPeriod || "") ===
                              String(rate.period || "")
                          ) {
                            setSelectedPackage(-1);
                            setSelectedPeriod("");
                            return;
                          }
                          setSelectedPackage(Number(pack?.packageId));
                          setSelectedPeriod(rate.period);
                        }}
                      >
                        {getPeriodLabel(rate.period)}
                      </button>
                    ))}
                  </div>
                )}
                <div className={styles.buttonContainer}>
                  <button
                    type="button"
                    className={`${styles.button} ${
                      isSelected
                        ? styles.buttonSelected
                        : styles.buttonDisabled
                    }`}
                    disabled={!isSelected}
                    aria-disabled={!isSelected}
                    onClick={() => {
                      if (isSelected) {
                        setSelectedPackage(-1);
                        setSelectedPeriod("");
                      }
                    }}
                  >
                    {isSelected
                      ? `Selected${
                          selectedPeriod
                            ? ` · ${getPeriodLabel(selectedPeriod)}`
                            : ""
                        }`
                      : "Select"}
                  </button>
                </div>
                <div className={styles.featuresContainer}>
                  <p>Plan includes</p>
                  {pack?.packageAmenities?.map((amenity: any, j: number) => {
                    return (
                      <div key={j} className={styles.feature}>
                        <div className={styles.iconContainer}>
                          <TickIcon className={styles.icon} />
                        </div>
                        <p className={styles.label}>{amenity}</p>
                      </div>
                    );
                  })}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  const Step5 = (props: { content: string }) => {
    const { content } = props;
    const contentRef = useRef<HTMLDivElement>(null);

    const handleDownloadPDF = () => {
      const element = contentRef.current;

      const opt: any = {
        margin: 0.5,
        filename: "Amengies Terms and Conditions.pdf",
        image: { type: "jpeg", quality: 1 },
        html2canvas: { scale: 2 },
        jsPDF: {
          unit: "in",
          format: "letter",
          orientation: "portrait",
        },
      };

      if (element) {
        html2pdf().set(opt).from(element).save();
      }
    };
    return (
      <div className={styles.stepFiveContainer}>
        <div className={styles.pdfButtonContainer}>
          <button className={styles.button} onClick={handleDownloadPDF}>
            <FaFilePdf className={styles.icon} />
          </button>
        </div>
        <div
          className={styles.contentContainer}
          dangerouslySetInnerHTML={{
            __html: content,
          }}
          ref={contentRef}
        ></div>
        <div className={styles.signatureContainer}>
          <p className={styles.label}>Sign the agreement</p>
          <div className={styles.signature}>
            <SignatureCanvas
              penColor="black"
              ref={signRef}
              canvasProps={{
                className: `${styles.signatureCanvas}`,
              }}
            />
          </div>
          <div className={styles.buttonContainer}>
            <button
              className={styles.clearButton}
              onClick={() => {
                if (signRef.current) {
                  signRef.current.clear();
                }
              }}
            >
              Clear
            </button>
          </div>
        </div>
      </div>
    );
  };

  const renderCurrentStep = () => {
    switch (currentStep) {
      case 0:
        return (
          <Step1
            email={email}
            setEmail={setEmail}
            password={password}
            setPassword={setPassword}
            confirmPassword={confirmPassword}
            setConfirmPassword={setConfirmPassword}
            showPassword={showPassword}
            setShowPassword={setShowPassword}
            showConfirmPassword={showConfirmPassword}
            setShowConfirmPassword={setShowConfirmPassword}
            errors={errors}
          />
        );
      case 1:
        return <Step2 />;
      case 2:
        return <Step3 />;
      case 3:
        return (
          <Step4
            familyMembers={familyMembers}
            setFamilyMembers={setFamilyMembers}
            packageData={packageData}
          />
        );
      case 4:
        return <Step5 content={memberByEmail?.termsAndConditions?.content} />;
      case 5:
        return (
          <Step6
            memberByEmail={memberByEmail}
            email={email}
            voucherCode={voucherCode}
            setVoucherCode={setVoucherCode}
            voucherSuccess={voucherSuccess}
            setVoucherSuccess={setVoucherSuccess}
            packageData={packageData}
            cardHolderName={cardHolderName}
            setCardHolderName={setCardHolderName}
            cardNumber={cardNumber}
            setCardNumber={setCardNumber}
            expiry={expiry}
            setExpiry={setExpiry}
            cvv={cvv}
            setCvv={setCvv}
            errors={errors}
            setErrors={setErrors}
            parkingIds={parkingIds}
            parkingList={memberByEmail?.parking || []}
            addonSelections={addonSelections}
            selectedPeriod={selectedPeriod}
          />
        );
      default:
        return <></>;
    }
  };

  const NonMemberModal = () => {
    return (
      <Modal
        isOpen={nonMemberModal}
        setIsOpen={setNonMemberModal}
        showCloseIcon={true}
      >
        <div className={styles.nonMemberModalContainer}>
          <div className={styles.iconContainer}>
            <IoIosWarning className={styles.icon} />
          </div>
          <div className={styles.descriptionContainer}>
            <p className={styles.description}>
              Oops! We did not find your data. If you are a member kindly
              contact with Building Administrator or continue as Non Member.
            </p>
          </div>
          <div className={styles.buttonContainer}>
            <Link
              className={styles.button}
              to="/signup/nonmember"
              state={{
                email,
                password,
                confirmPassword,
              }}
            >
              Continue as Non Member
            </Link>
          </div>
        </div>
      </Modal>
    );
  };

  return (
    <React.Fragment>
      <Header />
      <MobileHeader />
      <NonMemberModal />
      <AdditionalAmenitiesModal
        isOpen={additionalAmenitiesModal}
        setIsOpen={setAdditionalAmenitiesModal}
        parkingIds={parkingIds}
        setParkingIds={setParkingIds}
        notifyParkingIds={notifyParkingIds}
        setNotifyParkingIds={setNotifyParkingIds}
        parkingOptions={memberByEmail?.parking || []}
      />
      <AdditionalAddonsModal
        isOpen={additionalAddonsModal}
        setIsOpen={setAdditionalAddonsModal}
        addonSelections={addonSelections}
        setAddonSelections={setAddonSelections}
        addonOptions={memberByEmail?.addon || []}
      />
      <div className={styles.mainContainer}>
        <div className={styles.headingContainer}>
          <h3 className={styles.label}>Signup</h3>
        </div>
        <div className={styles.stepContainer}>
          <Stepper
            showLabel={true}
            currentStep={currentStep}
            steps={Array.from({ length: maxSteps }, (_, index) => ({
              id: index + 1,
              label: `Step ${index + 1}`,
            }))}
          />
        </div>
        <div className={styles.bodyContainer}>{renderCurrentStep()}</div>
        {memberByEmailLoading && <Loading />}
        {signupLoading && <Loading />}
        <div className={styles.buttonContainer}>
          <button className={styles.button} onClick={stepHandler}>
            Next
          </button>
        </div>

        {currentStep !== 0 && (
          <div className={styles.buttonContainer}>
            <button className={styles.back} onClick={backStepHandler}>
              Back
            </button>
          </div>
        )}
      </div>
    </React.Fragment>
  );
}

export default Signup;
